import { render, staticRenderFns } from "./FullScreenCalendar.vue?vue&type=template&id=e37c7090&scoped=true&"
import script from "./FullScreenCalendar.vue?vue&type=script&lang=ts&"
export * from "./FullScreenCalendar.vue?vue&type=script&lang=ts&"
import style0 from "./FullScreenCalendar.vue?vue&type=style&index=0&id=e37c7090&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e37c7090",
  null
  
)

export default component.exports